export enum PortfolioHistoryIntradayReportingEnum {
	MARKET_HOURS = 'market_hours',
	EXTENDED_HOURS = 'extended_hours',
	CONTINUOUS = 'continuous',
}
